import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useRequote = (applicationId) => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "requote"
  );
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [applicationId]);
  const requote = async ({
    mode,
    addonRate,
    term,
    repayment,
    costOfVessel,
    deposit,
    ignoreLimits,
    lookupRate,
    balloon,
  }) => {
    try {
      const result = await executeCallable({
        ...(mode === "term" ? { term } : { repayment }),
        // omit when unset so a standard quote sends the exact payload as before
        ...(balloon !== "" && balloon != null
          ? { balloon: Number(balloon) }
          : {}),
        mode,
        applicationId,
        addonRate,
        costOfVessel,
        deposit,
        ignoreLimits,
        lookupRate,
      });
      setComplete(true);
      if (!result?.data?.success) {
        console.error(result);
        throw new Error("Error requoting");
      }
      return true;
    } catch (err) {
      setComplete(false);
      return false;
    }
  };
  return { saving, error, success: !saving && !error && complete, requote };
};
